<template>
    <div class="flex flex-col justify-center min-h-screen py-12 bg-gray-50 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <img class="w-auto h-12 mx-auto" src="/img/logo.svg" alt="Logo a bit safer today">
        <h2 class="mt-6 text-3xl font-extrabold text-center text-gray-900">
            Nieuw wachtwoord instellen
        </h2>
        <p class="mt-2 text-sm text-center text-gray-600 max-w">
        <!-- Or
        <a href="#" class="font-medium text-lightblue-600 hover:text-lightblue-500">
            start your 14-day free trial
        </a> -->
        </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
            
            <!-- This example requires Tailwind CSS v2.0+ -->
            <transition
                enter-active-class="duration-300 ease-out"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="duration-200 ease-in"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div v-if="errors.email" class="p-4 mb-4 rounded-md bg-red-50">
                    <div class="flex">
                        <div class="flex-shrink-0">
                        <!-- Heroicon name: exclamation -->
                        <svg class="w-5 h-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                        </svg>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-sm font-medium text-red-800">
                                {{ errors.email }}
                            </h3>
                        </div>
                    </div>
                </div>
            </transition>

            <form class="space-y-6">
                <div>
                    <label for="email" class="block text-sm font-medium text-gray-700">
                        Email-adres
                    </label>
                    <div class="mt-1">
                        <input id="email" name="email" v-model="form.email" type="email" required placeholder="uwnaam@bedrijf.nl" class="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                    </div>
                </div>

                <div>
                    <label for="password" class="block text-sm font-medium text-gray-700">
                        Nieuw Wachtwoord (Minimaal 12 tekens)
                    </label>
                    <div class="mt-1">
                        <input id="password" name="password" v-model="form.password" type="password" required placeholder="*********" class="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                        
                    </div>
                </div>
                <div>
                    <label for="password_confirmation" class="block text-sm font-medium text-gray-700">
                        Bevestig nieuw wachtwoord
                    </label>
                    <div class="mt-1">
                        <input id="password_confirmation" name="password_confirmation" v-model="form.password_confirmation" type="password" required placeholder="*********" class="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm">
                        <span class="text-red-800 text-sm" v-if="errors.password" >{{ errors.password }}</span>
                    </div>
                </div>

                <input type="hidden" name="token" v-model="form.token" />

                <div>
                <a @click="submit()" class="flex justify-center w-full px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-lightblue-600 hover:bg-lightblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightblue-500">
                    Bevestig
                </a>
                </div>
            </form>
        </div>
    </div>
    </div>
</template>

<script>

import Layout from '@/Shared/Layout'

export default {
    components: {
        Layout,
    },
    props: {
        errors: Object,
    },
    data: () => ({
    form: {
        email: null,
        password: null,
        password_confirmation: null,
        token: new URLSearchParams(window.location.search).get('token'),
    }
    }),
    methods: {
        submit() {
            this.$inertia.post('/reset-password', this.form);
        }
    }
}

</script>
